import { useIntl } from '~/hooks/useIntl';
import { desktopTruncateStyle } from '~/styles/utilities.css';

type Props = {
  value: number;
};

export const InvoiceTotalCell = ({ value }: Props) => {
  const { formatCurrency } = useIntl();

  return <span className={desktopTruncateStyle}>{formatCurrency(value)}</span>;
};
